import { Component, OnInit } from '@angular/core';
import { DONATE_URL } from '../../../services/constants';
import { FormBuilder, Validators } from '@angular/forms';
import { LoginService } from '../../../services/login.service';
import { Router } from '@angular/router';

export type FooterSubscriptionFields = 'Email' | 'Company';

@Component({
	selector: 'footer-public',
	templateUrl: 'footer.component.html',
	styleUrls: ['./footer.component.scss']
})

export class FooterPublicComponent implements OnInit {

	form: FormGroup;

	public donationLink = DONATE_URL;

	public get f(): { [key in FooterSubscriptionFields]: AbstractControl } {
		return this.form ? this.form.controls as { [key in FooterSubscriptionFields]: AbstractControl } : null;
	}

	constructor(
		private _fb: FormBuilder,
		private _loginService: LoginService,
		private _router: Router,
	) {
	}

	ngOnInit(): void {
		this.form = this._fb.group({
			Email: ['', [Validators.required, Validators.email]],
			Company: [''] // honeypot
		});
	}

	submit(): void {
		if (this.f.Company.value) {
			return;
		}

		if (this.form.valid === false) {
			return;
		}

		this._loginService.subscribe(this.f.Email.value).then(() => {
			this._router.navigate(['thank-you']);
		});
	}
}
